var render, staticRenderFns
import script from "./custom-chart.vue?vue&type=script&lang=js&"
export * from "./custom-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.7.0_bwy4xudnfvux7ago3gnqb4adge/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports